<!-- 编辑销售报价单 (已废弃)-->
<template>
  <div class="business-content-main">
    <div style="margin-right: 80px">
      <div class="bread-nav">
        <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
      </div>
      <div class="section-title" @click="showMsg">
        <div>
          <span>订单信息</span>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span
            v-show="!showOrderMsg && submitData.EntpCusName"
          >客户：{{submitData.EntpCusName}}</span>
        </div>
        <div>
          <el-button
            size="small"
            class="search-btn btn-primary"
            @click="addCustomer(1)"
            v-if="type != 1&&submitData.CreatorType==0"
          >新增客户</el-button>
          <el-button
            size="small"
            class="search-btn btn-primary"
            @click="addCustomer(2)"
            v-if="type != 1 && submitData.EntpCusId"
          >编辑客户</el-button>
        </div>
      </div>
      <div class="open-icon" @click="showMsg" v-show="!showOrderMsg">
        <img src="../../../assets/images/open-msg.png" />
      </div>
      <div class="search-ctn" v-show="showOrderMsg">
        <el-form ref="form" label-width="80px" style="width: 100%" :rules="rules">
          <div class="form-main">
            <div class="form-left">
              <el-form-item label="选择客户" prop="EntpCusId">
                <el-select
                  style="width: 100%"
                  :disabled="type == 1||submitData.CreatorType!=0"
                  :loading="loading"
                  v-model="submitData.EntpCusId"
                  filterable
                  clearable
                  remote
                  @change="customerChange($event)"
                  @visible-change="customerVisibleChange($event)"
                  :remote-method="searchCustomer"
                  reserve-keyword
                  placeholder="选择客户"
                >
                  <el-option
                    v-for="optionItem in customerList"
                    :key="optionItem.EntpCusId"
                    :data-msg="optionItem"
                    :label="optionItem.EntpCusName"
                    :value="optionItem.EntpCusId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="询价日期">
                <el-date-picker
                  style="width: 100%"
                  :disabled="type == 1||submitData.CreatorType!=0"
                  value-format="yyyy-MM-dd"
                  v-model="submitData.ITime"
                  type="date"
                ></el-date-picker>
              </el-form-item>
            </div>
            <div class="form-center">
              <el-form-item label="运费" prop="PriceSumShip">
                <el-input
                  min="0"
                  style="width: 100%"
                  type="number"
                  step="0.01"
                  :disabled="type == 1"
                  v-model.trim="submitData.PriceSumShip"
                ></el-input>
              </el-form-item>
              <el-form-item label="报价日期">
                <el-date-picker
                  style="width: 100%"
                  :disabled="type == 1||submitData.CreatorType!=0"
                  value-format="yyyy-MM-dd"
                  v-model="submitData.QTime"
                  type="date"
                ></el-date-picker>
              </el-form-item>
            </div>
            <div class="form-right">
              <el-form-item label="期限日期">
                <el-date-picker
                  style="width: 100%"
                  :disabled="type == 1||submitData.CreatorType!=0"
                  value-format="yyyy-MM-dd"
                  v-model="submitData.NeedTime"
                  type="date"
                ></el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="form-bottom">
            <el-form-item label="客户要求" style="width: 66.6%">
              <el-input :disabled="type == 1||submitData.CreatorType!=0" v-model.trim="submitData.Remark"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="section-title" @click="hideMsg()">
        <div>商品明细</div>
        <div>
          <el-button
            size="small"
            class="search-btn btn-primary"
            @click="showSearch()"
            v-if="type != 1&&submitData.CreatorType==0"
          >搜索配件</el-button>
        </div>
      </div>
      <div class="div-table-row table-title" @click="hideMsg()">
        <div class="div-table-cell" style="width: 3%">
          序号
        </div>
        <div class="div-table-cell" style="width: 20%">
          <span class="color-red">*</span>汽配编码
        </div>
        <div class="div-table-cell" style="width: 17%">
          <span class="color-red">*</span>配件名称
        </div>
        <div class="div-table-cell" style="width: 16%">
          <span class="color-red">*</span>车型
        </div>
        <div class="div-table-cell" style="width: 8%">数量</div>
        <div class="div-table-cell" style="width: 8%">
          <span class="color-red">*</span>单位
        </div>
        <div class="div-table-cell" style="width: 9%">
          进货价
        </div>
        <div class="div-table-cell" style="width: 10%">
          <el-tooltip
            effect="dark"
            placement="bottom"
          >
            <div slot="content">
              当配件商品有过报价历史时，显示配件商品的最新报价价格；<br />
              若配件商品从未报价给客户时，则显示配件商品的零售价格
            </div>
            <span>
              <i class="el-icon-warning-outline" style="color:orange;margin-right:5px;"></i>
            </span>
          </el-tooltip>
          参考价
        </div>
        <div class="div-table-cell" style="width: 9%">
          <el-tooltip
            effect="dark"
            placement="bottom"
          >
            <div slot="content">
              当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格；<br />
              若配件商品从未销售过，则不显示数值
            </div>
            <span>
              <i class="el-icon-warning-outline" style="color:orange;margin-right:5px;"></i>
              <span class="color-red">*</span>
            </span>
          </el-tooltip>
          销售价
        </div>
        <div class="div-table-cell" style="width: 9%">备注</div>
      </div>
    </div>
    <!--    查看    -->
    <div v-if="type == 1" style="margin-right: 80px">
      <div
        id="infinite-list"
        class="table-main infinite-list"
        :style="{ height: infiniteListHeight + 'px' }"
        @click="hideMsg()">
        <div
          class="div-table-row table-item"
          v-for="(item,index) in dataList"
          v-bind:key="index">
          <div class="div-table-cell" style="width: 3%">
            {{index + 1}}
          </div>
          <div class="div-table-cell div-table-cell-code" style="width: 20%">
            <img
              src="../../../assets/images/info.png"
              alt
              title="配件信息"
              class="info-icon"
              @click="showAPMsgDialog(item.EntpTempGoodsId)"
            />
            <el-tooltip effect="dark" :content="item.APCode" placement="top">
              <span>{{item.APCode}}</span>
            </el-tooltip>
            <div v-if="item.State==1" class="row-delete">已删除</div>
          </div>
          <div class="div-table-cell" style="width: 17%">
            <el-tooltip effect="dark" :content="item.GoodName" placement="top">
              <span>{{item.GoodName}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 16%">
            <el-tooltip effect="dark" :content="item.AutoSerise" placement="top">
              <span>{{item.AutoSerise}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 8%">
            <el-tooltip effect="dark" :content="item.Count.toString()" placement="top">
              <span>{{item.Count}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 8%">{{item.Unit}}</div>
          <div class="div-table-cell" style="width: 9%">
            <el-tooltip effect="dark" :content="item.CostPrice.toString()" placement="top">
              <span>{{item.CostPrice}}</span>
            </el-tooltip>
          </div>
          <!--          参考价          -->
          <div class="div-table-cell" style="width: 10%">
              <img
                src="../../../assets/images/info.png"
                alt
                title="历史销售"
                class="info-icon"
                @click="showHistoryDialog(item.EntpTempGoodsId)"
              />
              <el-tooltip
                effect="dark"
                :content="item.ReferencePrice.toString()"
                placement="top"
              >
                <span>{{ item.ReferencePrice }}</span>
              </el-tooltip>            
          </div>
          <div class="div-table-cell" style="width: 9%">
            <el-tooltip effect="dark" :content="item.MarketPrice.toString()" placement="top">
              <span>{{item.MarketPrice}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 9%">
            <el-tooltip effect="dark" :content="item.Remark.toString()" placement="top">
              <span>{{item.Remark}}</span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!--    新增编辑    -->
    <div v-else>
      <div
        id="infinite-list"
        class="infinite-list"
        :style="{ height: infiniteListHeight + 'px' }"
        v-infinite-scroll="loadDownScroll"
        infinite-scroll-distance="10"
        :infinite-scroll-immediate="false">
        <div class="edit-ctn" @click="hideMsg()">
          <div class="table-main">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              style="margin-right: 80px">
              <div
                v-if="index >= startIdx && index <= endIdx"
                class="div-table-row table-item"
                :ref="'pj' + index">
                  <!--        编码            -->
                  <div class="div-table-cell" style="width: 3%">
                    {{index + 1}}
                  </div>
                  <div
                    class="div-table-cell div-table-cell-code"
                    style="width: 20%"
                    :class="{'check-code-class':item.CodeRepeat}"
                  >
                    <img
                      src="../../../assets/images/info.png"
                      alt
                      title="配件信息"
                      class="info-icon"
                      @click="showAPMsgDialog(item.EntpTempGoodsId)"
                    />
                    <el-select
                      :ref="'code' + index"
                      :loading="loading"
                      allow-create
                      default-first-option
                      size="small"
                      v-model="item.APCode"
                      value-key="APCode"
                      filterable
                      clearable
                      remote
                      reserve-keyword
                      placeholder="汽配编码"
                      @focus="hideMsg"
                      @change="codeChange($event,index)"
                      @visible-change="apCodeVisibleChange($event)"
                      :remote-method="searchCode"
                      :disabled="submitData.CreatorType!=0"
                      popper-class="el-select-style-gray"
                    >
                      <el-option
                        v-for="optionItem in codeList"
                        :key="optionItem.EntpTempGoodsId"
                        :data-msg="optionItem"
                        :label="optionItem.APCode"
                        :value="optionItem.APCode"
                      >
                        <div class="option-content">
                          <div style="width: 200px">{{optionItem.APCode}}</div>
                          <div style="width: 200px">{{optionItem.GoodName}}</div>
                          <div class="in-one-line" style="width: 200px">{{optionItem.AutoSerise}}</div>
                        </div>
                      </el-option>
                    </el-select>
                    <div v-if="item.State==1" class="row-delete">已删除</div>
                  </div>
                  <!--        名称            -->
                  <div class="div-table-cell" style="width: 17%">
                    <el-input size="small" v-model="item.GoodName" v-if="item.IsNew" placeholder="配件名称"></el-input>
                    <el-select
                      v-else
                      style="width: 100%"
                      :loading="loading"
                      allow-create
                      size="small"
                      v-model="item.GoodName"
                      filterable
                      clearable
                      remote
                      reserve-keyword
                      placeholder="配件名称"
                      @focus="hideMsg"
                      @change="nameChange($event,index)"
                      @visible-change="apNameVisibleChange($event)"
                      :remote-method="searchName"
                      :disabled="submitData.CreatorType!=0"
                      popper-class="el-select-style-gray"
                    >
                      <el-option
                        v-for="optionItem in nameList"
                        :key="optionItem.EntpTempGoodsId"
                        :data-msg="optionItem"
                        :label="optionItem.GoodName"
                        :value="optionItem.GoodName"
                      >
                        <div class="option-content">
                          <div style="width: 200px">{{optionItem.GoodName}}</div>
                          <div style="width: 200px">{{optionItem.APCode}}</div>
                          <div class="in-one-line" style="width: 200px">{{optionItem.AutoSerise}}</div>
                        </div>
                      </el-option>
                    </el-select>
                  </div>
                  <!--        车系            -->
                  <div class="div-table-cell" style="width: 16%">
                    <el-tooltip effect="dark" :content="item.AutoSerise" :disabled="!item.AutoSerise" placement="top">
                    <el-input size="small" v-model="item.AutoSerise" v-if="item.IsNew" placeholder="车系"></el-input>
                    <el-select
                      v-else
                      :loading="loading"
                      allow-create
                      size="small"
                      v-model="item.AutoSerise"
                      filterable
                      clearable
                      remote
                      reserve-keyword
                      placeholder="车系"
                      @focus="hideMsg"
                      @change="serieChange($event,index)"
                      @visible-change="autoSeriseVisibleChange($event)"
                      :remote-method="searchAutoSerie"
                      :disabled="submitData.CreatorType!=0"
                      popper-class="el-select-style-gray"
                    >
                      <el-option
                        :loading="true"
                        v-for="item in seriesList"
                        :key="item.SeriesId"
                        :label="item.SeriesName"
                        :value="item.SeriesName"
                      ></el-option>
                    </el-select>
                    </el-tooltip>
                  </div>
                  <!--        数量            -->
                  <div class="div-table-cell" style="width: 8%">
                    <el-input-number
                      :ref="'count'+ index"
                      :min="1"
                      :precision="0"
                      controls-position="right"
                      size="small"
                      v-model="item.Count"
                      :disabled="type == 4"
                    ></el-input-number>
                  </div>
                  <!--        单位         -->
                  <div class="div-table-cell" style="width: 8%">
                    <el-select
                      default-first-option
                      size="small"
                      v-model="item.Unit"
                      filterable
                      clearable
                      remote
                      @focus="hideMsg"
                      reserve-keyword
                      placeholder="单位"
                      @visible-change="unitVisibleChange($event)"
                      :disabled="submitData.CreatorType!=0"
                      popper-class="el-select-style-gray"
                    >
                      <el-option
                        v-for="optionItem in unitList"
                        :key="optionItem.Value"
                        :label="optionItem.Value"
                        :value="optionItem.Value"
                      ></el-option>
                    </el-select>
                  </div>
                  <!--          进货价          -->
                  <div class="div-table-cell" style="width: 9%">
                    <el-input-number :min="0" :precision="2" :step="0.01" controls-position="right" size="small" v-model="item.CostPrice"></el-input-number>
                  </div>
                  <!--          参考价          -->
                  <div class="div-table-cell" style="width: 10%">
                      <img
                        src="../../../assets/images/info.png"
                        alt
                        title="历史销售"
                        class="info-icon"
                        @click="showHistoryDialog(item.EntpTempGoodsId)"
                      />
                      <el-tooltip
                        effect="dark"
                        :content="item.ReferencePrice.toString()"
                        placement="top"
                      >
                        <span>{{ item.ReferencePrice }}</span>
                      </el-tooltip>            
                  </div>
                  <!--          销售价          -->
                  <div class="div-table-cell" style="width: 9%">
                    <el-input-number :min="0" :precision="2" :step="0.01" controls-position="right" size="small" v-model="item.MarketPrice" placeholder="销售价"></el-input-number>
                  </div>
                  <!--        备注           -->
                  <div class="div-table-cell" style="width: 9%">
                    <el-input size="small" v-model="item.Remark"></el-input>
                  </div>
                  <el-button class="less-btn" icon="el-icon-minus" circle @click="delItem(index)" v-if="submitData.CreatorType==0"></el-button>
                  <el-button class="add-btn" type="primary" icon="el-icon-plus" circle @click="addItem" v-if="submitData.CreatorType==0 && index + 1 === dataList.length"></el-button>
              </div>
            </div>
            <div class="infinite-loading" v-if="showInfiniteLoading">
              <i class="el-icon-loading" />加载中
            </div>
            <!-- <div style="margin-right: 80px">
              <el-button class="add-btn" type="primary" icon="el-icon-plus" circle @click="addItem" v-if="submitData.CreatorType==0"></el-button>
            </div> -->
            <!--         历史       -->
            <div class="history-main" :style="historyStyle" v-if="showHistory">
              <div v-if="historyNoData" class="history-no-data" @click="chooseHistory()">无相关配件</div>
              <div v-else>
                <div style="padding-bottom: 10px">
                  可能的历史报价
                  <el-button
                    size="small"
                    class="search-btn btn-primary"
                    style="float: right;"
                    @click="chooseHistory()"
                  >关闭</el-button>
                </div>
                <div
                  class="history-row"
                  v-for="(item) in historyList"
                  @click="chooseHistory(item)"
                  v-bind:key="item.index"
                >
                  <div class="history-cell">
                    <div v-html="item.APCode_Rendering"></div>
                  </div>
                  <div class="history-cell">
                    <div v-html="item.GoodName_Rendering"></div>
                  </div>
                  <div class="history-cell">
                    <div v-html="item.AutoSerise"></div>
                  </div>
                  <div class="history-cell">
                    <div v-html="item.Count"></div>
                  </div>
                  <div class="history-cell">
                    <div v-html="item.Unit"></div>
                  </div>
                  <div class="history-cell">
                    <div v-html="item.CostPrice"></div>
                  </div>
                  <div class="history-cell">
                    <div v-html="item.MarketPrice"></div>
                  </div>
                  <div class="history-cell">
                    <div v-html="item.Remark"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-ctn">
            <el-button size="small" class="search-btn btn-primary" @click="submitForm()">提交报价</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="customerEditType==2?'编辑客户':'新增客户'"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <div class="dialog-content" v-if="dialogVisible">
        <customerEdit
          ref="customerEdit"
          :cusId="submitData.EntpCusId"
          :type="customerEditType"
          source="1"
          @closeDialog="closeDialog"
        ></customerEdit>
      </div>
    </el-dialog>
    <!--   配件信息     -->
    <el-dialog
      :close-on-click-modal="false"
      title="配件信息"
      :visible.sync="APMsgVisible"
      width="1000px"
    >    
      <div v-if="APMsgVisible">    
        <APMsg
          :dialogFormVisible="APMsgVisible"
          :EntpTempGoodsId="EntpTempGoodsIdEdit"
          @closeDialog="closeAPMsgDialog"
        ></APMsg>
      </div>
    </el-dialog>     
    <!--   搜索配件    -->
    <el-dialog
      :close-on-click-modal="false"
      title="搜索配件"
      :visible.sync="searchVisible"
      width="1200px"
    >
      <div v-if="searchVisible">
        <searchAP :EntpCusId="submitData.EntpCusId" @closeDialog="closeSearchDialog"></searchAP>
      </div>
    </el-dialog>
    <!--    销售历史    -->
    <el-dialog
      :close-on-click-modal="false"
      title="销售历史"
      :visible.sync="historyVisible"
      width="1200px"
    >
      <div v-if="historyVisible">
        <APHistory
          :EntpCusId="submitData.EntpCusId"
          :EntpTempGoodsId="EntpTempGoodsIdEdit"
          :EntpCusName="submitData.EntpCusName"
          @closeDialog="closeHistoryDialog"
        ></APHistory>
      </div>
    </el-dialog>    
  </div>
</template>
<script>
import customerEdit from "@/components/business/customerManage/customerEdit";
import APMsg from "@/components/common/APMsg";
import searchAP from "@/components/common/searchAP";
import APHistory from "@/components/common/APHistory";
import mixin from "@/mixins/mixin";
import breadcrumb from "@/components/common/breadcrumb";
export default {
  mixins: [mixin],
  name: "",
  components: {
    customerEdit,
    APMsg,
    searchAP,
    APHistory,
    breadcrumb
  },
  data() {
    let checkPositive = this.$util.checkPositive;
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      needConfirm: true,
      dialogVisible: false,
      searchVisible: false,
      historyVisible:false,
      APMsgVisible: false,
      EntpTempGoodsIdEdit: "",
      showHistory: false,
      historyNoData: true,
      loading: false,
      showOrderMsg: true,
      canRequest: true,
      customerEditType: 1,
      historyStyle: {
        top: ""
      },
      editIndex: -1,
      submitData: {
        QuoteId: "",
        UserId: userMsg.EmployeeId,
        EntpCusId: "",
        NeedTime: "",
        Remark: "",
        PriceSumShip: "",
        ITime: "",
        QTime: "",
        IsSubmitReview: false,
        CreatorType:0,
        DetailList: []
      },
      Limit: 10,
      download_url: this.$util.QN_URL_BASE,
      customerList: [],
      codeList: [],
      nameList: [],
      seriesList: [],
      dataList: [],
      historyList: [],
      unitList: [],
      type: 1, //  1 查看 2 编辑 3 新增 4 从库存配件管理过来的
      id: "",
      pageTitle: "",
      rules: {
        EntpCusId: [{ required: true, message: "请选择客户", trigger: "blur" }],
        PriceSumShip: [
          { required: false, validator: checkPositive, trigger: "blur" }
        ]
      },

      startIdx: 0, // 列表显示的第一个列的下标
      endIdx: 49, // 列表显示的最后一个列的下标
      stopLoad: false, // 停止监听上下滚动
      windowHeight: window.innerHeight,
      infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
      scrollPosition: 0, // 滚动条位置，用于判断是否收起信息栏
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$util.confirmBeforeLeave(to, from, next, this);
  },
  mounted() {
    let fullPath = this.$route.fullPath;
    document.onkeydown = event => {
        let isDialog =document.querySelector(".v-modal");
        let layui=document.querySelectorAll(".layui-layer");      
      if (
        fullPath == this.$route.fullPath &&
        !this.dialogVisible &&
        !this.historyVisible &&
        !this.searchVisible &&
        !this.APMsgVisible&&!isDialog&&layui.length<=1
      ) {
        let e = event || window.event || arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 13) {
          this.addItem();
        }
      }
    };
    this.id = this.$route.query.id;
    this.submitData.QuoteId = this.$route.query.id;
    this.type = this.$route.query.type;
    if (this.type == 1) {
      this.pageTitle = "查看报价单";
      this.getBJOrder();
    } else if (this.type == 2) {
      this.pageTitle = "编辑报价单";
      this.getBJOrder();
    } else if (this.type == 3) {
      this.pageTitle = "新增报价单";
      this.addItem();
    } else if (this.type == 4) {
      this.pageTitle = "再次报价单";
      this.bjAgain();
    }
    setTimeout(() => {
      this.resetHeight();
    }, 0);
    // 监听滚动事件
    document.addEventListener("scroll", this.loadTopScroll, true);
    window.onresize = () => { this.resetHeight() }
    // 给business-content强行写入css样式
    let bc = document.getElementsByClassName("business-content")[0];
    if (bc) {
      bc.style.overflow = "hidden";
      bc.style.scrollbarWidth = "none";
    }
  },
  destroyed() {
    document.removeEventListener("scroll", this.loadTopScroll, true);
    let bc = document.getElementsByClassName("business-content")[0];
    bc.style.overflow = "auto";
    bc.style.scrollbarWidth = "auto";
  },
  watch: {
    showOrderMsg() {
      let topValue = document.getElementById("infinite-list").scrollTop;
      this.scrollPosition = topValue;
    }
  },
  computed: {
    // 是否显示loading
    showInfiniteLoading() {
      return this.endIdx < this.dataList.length - 1;
    },
  },
  methods: {
    /**
     * 向上滚动
     * topValue: 距离顶部距离
     */
    loadTopScroll() {
      let topValue = document.getElementById("infinite-list").scrollTop;
      if (this.showOrderMsg && topValue > this.scrollPosition) {
        this.scrollPosition = topValue;
        this.hideMsg();
      }
      if (topValue > 150 || this.stopLoad) return;
      this.stopLoad = true;
      if (this.startIdx > 0) {
        if (this.startIdx < 25) {
          let over = this.startIdx;
          this.startIdx -= Math.abs(over);
          this.endIdx -= Math.abs(over);
          this.$message({
            type: "info",
            offset: this.windowHeight / 2,
            message: "您现在在顶部",
          });
        } else if (this.startIdx >= 25) {
          this.startIdx -= 25;
          this.endIdx -= 25;
          if (this.startIdx === 0) {
            this.$message({
              type: "info",
              offset: this.windowHeight / 2,
              message: "您现在在顶部",
            });
          } else {
            // 对火狐浏览器做特殊处理
            if (navigator.userAgent.indexOf("Firefox") >= 0) {
              let sh =
                document.getElementById("infinite-list").scrollHeight / 4;
              document.getElementById("infinite-list").scrollTop = sh;
            }
          }
        }
      }
      this.stopLoad = false;
    },
    // 向下滚动
    loadDownScroll() {
      let listLastIndex = this.dataList.length - 1;
      if (listLastIndex < 50 || this.stopLoad) return;
      this.stopLoad = true;
      if (this.endIdx < listLastIndex) {
        if (this.endIdx + 25 <= listLastIndex) {
          this.startIdx += 25;
          this.endIdx += 25;
          if (this.endIdx === this.listLastIndex) {
            this.$message({
              type: "info",
              offset: this.windowHeight / 2,
              message: "您已经触底了哦~",
            });
          }
        } else {
          let over = this.endIdx;
          this.startIdx += listLastIndex - over;
          this.endIdx += listLastIndex - over;
          this.$message({
            type: "info",
            offset: this.windowHeight / 2,
            message: "您已经触底了哦~",
          });
        }
      }
      this.stopLoad = false;
    },
    // 计算infinite-list高度
    resetHeight() {
      let listObj = document.getElementById("infinite-list");
      if (!listObj) return;
      let clientObj = listObj.getBoundingClientRect();
      this.infiniteListHeight = window.innerHeight - clientObj.top;
    },
    getConfigData() {
      this.$util.getConfigData("Unit").then(res => {
        this.unitList = res;
      });
    },
    // 搜索
    showSearch() {
      this.searchVisible = true;
    },
    closeSearchDialog(items) {
      let that = this;      
      let itemList = [...items];
      if(itemList.length == 0){
          that.searchVisible = false;
          return;
      }      
      let newGoodsList=[];
      for(let i = 0; i < itemList.length; i++){
          let item= itemList[i] ;
          let goods=that.dataList.find((e)=>item.APCode==e.APCode);
          if(!goods){
            let newGoods={
                  ReferencePrice: item.ReferencePrice,
                  EntpTempGoodsId: item.EntpTempGoodsId,
                  APCode: item.APCode,
                  GoodName: item.GoodName,
                  AutoSerise: item.AutoSerise,
                  Count: 1,
                  Price: item.Price ? item.Price : 0,
                  MarketPrice:item.LatestPrice > 0? item.LatestPrice: "",
                  Unit: item.Unit,
                  Remark: item.Remark,
                  CodeRepeat: false,
                  State: 0,
                  CostPrice: 0
                  };
            newGoodsList.push(newGoods);
          }
      }
      //判断最后一条数据是否空值，是的话移到最后
      if(that.dataList.length==0){
        that.dataList=that.dataList.concat(newGoodsList);
      }else{
        let lastItem=that.dataList[that.dataList.length-1];
        if(!lastItem.APCode&&!lastItem.GoodName){
          that.dataList.splice(that.dataList.length-1, 1);
          that.dataList=that.dataList.concat(newGoodsList);
          that.dataList.push(lastItem);
        }else{
           that.dataList=that.dataList.concat(newGoodsList);
        }
      } 
      that.searchVisible = false;
      that.$nextTick(() => {
        if(that.$refs["count" + (that.dataList.length - 1).toString()]){
          that.$refs["count" + (that.dataList.length - 1).toString()][0].focus();
        }
      });
    },
    // 配件信息
    showAPMsgDialog(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.APMsgVisible = true;
      }
    },
    closeAPMsgDialog(edit) {
      this.APMsgVisible = false;
      if (edit) {
        this.getOrderDetail();
      }
    },
    // 配件信息
    hideMsg() {
      this.showOrderMsg = false;
      setTimeout(() => {
        this.resetHeight();
      }, 100);
    },
    showMsg() {
      this.showOrderMsg = true;
      setTimeout(() => {
        this.resetHeight();
      }, 100);
    },
    closeDialog(edit) {
      this.dialogVisible = false;
      if (edit) {
        this.searchCustomer();
      }
    },
    addCustomer(type) {
      this.customerEditType = type;
      this.dialogVisible = true;
    },
    chooseHistory(item) {
      this.showHistory = false;
      if (item) {
        let target = this.dataList[this.editIndex];
        target.APCode = item.APCode;
        target.AutoSerise = item.AutoSerise;
        target.CostPrice = item.CostPrice;
        target.GoodName = item.GoodName;
        target.MarketPrice = item.MarketPrice;
        target.Unit = item.Unit;
      }
    },
    customerChange(value){
      let that = this;
      if(!value)
      that.submitData.EntpCusName = "";
      else{
           let currCust = that.customerList.find((e) => e.EntpCusId == value);
        if (currCust) {
          that.submitData.EntpCusName = currCust.EntpCusName;
          }
      }
    },
    //
    bjAgain() {
      this.$util
        .axiosGet({
          url:
            "/api/EntpSaleOrder/GetOrderforQuote",
          data: {
            EntpCusOId: this.id,
          }
        })
        .then(res => {
          res.data.EntpCusOId = this.id;
          res.data.UserId = this.userMsg.EmployeeId;
          this.submitData = res.data;
          this.dataList = res.data.DetailList;
          this.customerList.push({
            EntpCusId: res.data.EntpCusId,
            EntpCusName: res.data.EntpCusName
          });
        });
    },
    // 如果是查看获取询价单详情
    getBJOrder() {
      this.$util
        .axiosGet({
          url:
            "/api/EntpQuotationOrder/GetQuotationOrder",
          data: {
            QuoteId: this.id,
          }
        })
        .then(res => {
          res.data.QuoteId = this.id;
          res.data.UserId = this.userMsg.EmployeeId;
          this.customerList.push({
            EntpCusId: res.data.EntpCusId,
            EntpCusName: res.data.EntpCusName
          });
          this.submitData = res.data;
          this.dataList = res.data.DetailList;
        });
    },
    // 提交询价单
    submitForm() {
      let _dataList = this.dataList;
      if (!this.submitData.EntpCusId) {
        this.$util.warningMsg("请选择客户");
        return;
      }
      if (this.submitData.PriceSumShip < 0) {
        this.$util.warningMsg("运费不能小于0");
        return;
      }
      for (let i = 0; i < _dataList.length; i++) {
        if (!_dataList[i].APCode) {
          this.$util.warningMsg("请填写配件编码");
          return;
        }
        if (!_dataList[i].GoodName) {
          this.$util.warningMsg("请填写配件名称");
          return;
        }
        if(_dataList[i].State != 0){
          this.$util.warningMsg("商品【"+_dataList[i].GoodName+"（"+_dataList[i].APCode+"）"+"】已删除");
          return;
        }
        if (!_dataList[i].AutoSerise) {
          this.$util.warningMsg("请填写车型");
          return;
        }
        if (!_dataList[i].Unit) {
          this.$util.warningMsg("请填写单位");
          return;
        }
        if (_dataList[i].CostPrice && _dataList[i].CostPrice < 0) {
          this.$util.warningMsg("进货价不能小于0");
          return;
        }
        if (
          !_dataList[i].MarketPrice ||
          Number(_dataList[i].MarketPrice) <= 0
        ) {
          this.$util.warningMsg(`请给序号为 ${i + 1} 的商品填写正确的销售价`);
          return;
        }
      }
      this.submitData.DetailList = _dataList;
      if (!this.canRequest) {
        return;
      }
      this.canRequest = false;
      this.$util
        .axiosPost({
          url:
            "/api/EntpQuotationOrder/SaveQuotationOrder",
          data: this.submitData
        })
        .then(() => {
          this.needConfirm = false;
          this.$util.successMsg("提交报价单成功");
          //编辑后列表页面需要刷新
          this.$store.commit("updateNeedRefresh", true);
          setTimeout(() => {
            this.canRequest = true;
            this.$router.push("/salesManage/quotation");
          }, 2000);
        })
        .catch(() => {
          this.canRequest = true;
        });
    },
    // 删除某行
    delItem(index) {
      if (this.dataList.length != 1) {
        this.dataList.splice(index, 1);
      }
    },
    // 添加一行
    addItem() {
      let _dataList = this.dataList;
      for (let i = 0; i < _dataList.length; i++) {
        if (!_dataList[i].APCode) {
          this.$util.warningMsg("请填写配件编码");
          return;
        }
        if (!_dataList[i].GoodName) {
          this.$util.warningMsg("请填写配件名称");
          return;
        }
        if (!_dataList[i].AutoSerise) {
          this.$util.warningMsg("请填写车型");
          return;
        }
        if (!_dataList[i].Unit) {
          this.$util.warningMsg("请填写单位");
          return;
        }
        if (!_dataList[i].MarketPrice) {
          this.$util.warningMsg("请填写销售价");
          return;
        }
      }
      this.dataList.push({
        EntpTempGoodsId: "",
        APCode: "",
        GoodName: "",
        AutoSerise: "",
        Count: "1",
        ReferencePrice:"0",
        MarketPrice: "",
        CostPrice: "0",
        Unit: "",
        Remark: "",
        CodeRepeat: false,
        IsNew: false,
        State: 0
      });

      // 当dataList数量大于50时
      if (this.dataList.length > 50) {
        this.startIdx += 1;
        this.endIdx += 1;
      }
    },
    // 搜索顾客
    searchCustomer(key) {
      this.loading = true;
      this.customerList = [];
      this.$util
        .searchCustomer(key)
        .then(data => {
          this.customerList = data;
          // this.customerList = this.$util.uniqueArr(this.customerList, res.data);
          //修改客户时要更新页面上展现的名称
          if(this.customerList.length>0){
              let currCust = this.customerList.find((e) => e.EntpCusId == this.submitData.EntpCusId);
              if(currCust){
                this.submitData.EntpCusName = currCust.EntpCusName;
              }
          }           
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 搜索汽配编码
    searchCode(key) {
      this.loading = true;
      this.$util
        .axiosGet({
          url:"/api/EntpGoods/GetGoodsSelItemsForSaleOrder",
          data: {
            APCode: key,
            Limit: this.Limit,
            EntpId: this.userMsg.EntpId,
            CId: this.submitData.EntpCusId,
            SFrom:'apc'
          },
          hideLoading: true
        })
        .then(res => {
          this.loading = false;
          this.codeList = res.data;
        });
    },
    // 搜索名称
    searchName(key) {
      this.loading = true;
      this.$util
        .axiosGet({
          url:"/api/EntpGoods/GetGoodsSelItemsForSaleOrder",
          data: {
            GoodName: key,
            Limit: this.Limit,
            EntpId: this.userMsg.EntpId,
            CId: this.submitData.EntpCusId,
            SFrom:'gn'
          },
          hideLoading: true
        })
        .then(res => {
          this.loading = false;
          this.nameList = res.data;
        });
    },
    // 搜车系
    searchAutoSerie(key) {
      this.loading = true;
      this.$util
      .searchAutoSerie(key)
      .then(data => {
        this.seriesList = data;
        this.loading = false;
      });        
    },
    // 名称改变
    nameChange(value, index) {
      this.editIndex = index;
      let _list = this.nameList;
      // this.searchHistory("GoodName", value, index);
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].GoodName == value) {
          this.dataList[index].CostPrice = _list[i].CostPrice;
          this.dataList[index].MarketPrice = _list[i].LatestPrice > 0? _list[i].LatestPrice: "";
          this.dataList[index].Unit = _list[i].Unit;
          this.dataList[index].AutoSerise = _list[i].AutoSerise;
          this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
          this.dataList[index].State = 0;
          if (!this.dataList[index].APCode) {
            this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
            this.dataList[index].APCode = _list[i].APCode;
          }
        }
      }
    },
    // 编码改变
    codeChange(value, index) {
      let isNew = true;
      this.checkCodeRepeat();
      this.editIndex = index;
      let _list = this.codeList;
      if (!value) {
        this.dataList[index].IsNew = false;
      }
      // this.searchHistory("APCode", value, index);
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].APCode == value) {
          this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
          this.dataList[index].AutoSerise = _list[i].AutoSerise;
          this.dataList[index].CostPrice = _list[i].CostPrice;
          this.dataList[index].MarketPrice = _list[i].LatestPrice > 0? _list[i].LatestPrice: "";
          this.dataList[index].Unit = _list[i].Unit;
          this.dataList[index].GoodName = _list[i].GoodName;
          this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
          this.dataList[index].IsNew = false;
          this.dataList[index].State = 0;
          isNew = false;
        }
      }
      if (isNew && value) {
        let that = this;
        this.$util.elConfirm({
          content: "要创建一个新配件吗？",
          noMsg: true,
          confirm() {
            that.dataList[index].EntpTempGoodsId = "";
            that.dataList[index].Inventory = 0;
            that.dataList[index].MarketPrice = 0;
            that.dataList[index].CostPrice = 0;
            that.dataList[index].ReferencePrice = "0";
            that.dataList[index].IsNew = true;
            that.dataList[index].State = 0;
            that.$nextTick(() => {
              that.$refs["code" + index][0].blur();
            });
            that.$util
              .axiosGet({
                url: "/api/EntpGoods/GetPart",
                data: {
                  APCode: value
                },
                hideLoading: true
              })
              .then(res => {
                if (res.data) {
                  let data = res.data;
                  that.dataList[index].APCode = data.APCode;
                  that.dataList[index].AutoSerise = data.AutoSerise;
                  that.dataList[index].GoodName = data.GoodName;
                  that.dataList[index].Unit = data.Unit;
                }
              });
          }
        });
      }
    },
    checkCodeRepeat() {
      let repeatIndexs = [];
      let obj = {};
      let _dataList = this.dataList;
      for (let i = 0; i < _dataList.length; i++) {
        _dataList[i].CodeRepeat = false;
        if (!obj[_dataList[i].APCode]) {
          obj[_dataList[i].APCode] = [i];
        } else {
          obj[_dataList[i].APCode].push(i);
        }
      }
      for (let key in obj) {
        if (obj[key].length >= 2) {
          repeatIndexs = [...repeatIndexs, ...obj[key]];
        }
      }
      for (let j = 0; j < repeatIndexs.length; j++) {
        this.dataList[repeatIndexs[j]].CodeRepeat = true;
      }
    },
    // 车系改变
    serieChange(value, index) {
      this.searchAutoSerie();
    },
        // 历史销售
    showHistoryDialog(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.historyVisible = true;
      }
    },
    closeHistoryDialog(edit) {
      this.historyVisible = false;
    },
    // 搜历史,已弃用 edit by 2020/12/30
    searchHistory(key, value, index) {
      let target = this.$refs["pj" + index][0];
      this.historyStyle.top = target.offsetTop + 80 + "px";
      let _data = {
        EntpId: this.userMsg.EntpId,
        APCode: "",
        GoodName: "",
        Limit: 3
      };
      _data[key] = value;
      this.$util
        .axiosGet({
          url: "/search/Search/EnterpriseCustomerQuotationSearch",
          data: _data,
          hideLoading: true,
          search: true
        })
        .then(res => {
          this.historyList = res.data;
          if (res.data.length > 0) {
            this.showHistory = true;
            this.historyNoData = false;
          } else {
            this.showHistory = false;
            this.historyNoData = true;
          }
        });
    },

    //单位下拉框显示时触发event
    unitVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.unitList.length == 0) that.getConfigData();
      }
    },
    //当供应商下拉框出现时触发
    customerVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.customerList.length <= 1) that.searchCustomer();
      }
    },
    //当汽配件编码下拉框出现时触发
    apCodeVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.codeList.length == 0) that.searchCode();
      }
    },
    //当汽配件名称下拉框出现时触发
    apNameVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.nameList.length == 0) that.searchName();
      }
    },
    //当车系下拉框出现时触发
    autoSeriseVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.seriesList.length == 0) that.searchAutoSerie();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.form-main {
  display: flex;
  > div {
    width: 33.33%;
  }
}
.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}
.edit-ctn {
  .div-table-cell {
    padding: 0 5px;
  }
}
.search-ctn {
  border: 1px solid @border3Color;
  padding-top: 20px;
  margin-bottom: 20px;
}
.option-content {
  display: flex;
  line-height: 30px;
}
.btn-ctn {
  padding: 30px 0;
  margin-right: 110px;
  text-align: right;
  padding-bottom: 240px;
}
.add-btn {
  position: absolute;
  right: -40px;
  bottom: -40px;
}
.less-btn {
  position: absolute;
  right: -40px;
  top: 4px;
  z-index: 2;
}
// .business-content-main {
//   // padding-right: 80px;
// }
.table-main {
  position: relative;
}
.image-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border: 1px dashed @border3Color;
}
.table-title {
  line-height: 36px;
  text-align: center;
  font-weight: bold;
}
.div-table-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.table-item {
  height: 50px;
  position: relative;
}
.div-table-row {
  overflow: inherit;
  margin-left: 0;
}
.div-table-cell-code {
  position: relative;
  .row-delete {
    position: absolute;
    padding: 1px 6px;
    top: 0;
    right: 0;
    color: #fff;
    background: #FFCC66;
    border-radius: 12.5px;
  }
}
.history-main {
  position: absolute;
  left: 0;
  width: 100%;
  height: 140px;
  overflow: auto;
  padding: 10px;
  border: 1px solid @border3Color;
  background: white;
  z-index: 2;
  box-shadow: 10px 10px 5px #888888;
  .history-row {
    display: flex;
    align-items: center;
    cursor: pointer;
    overflow: inherit;
    position: relative;
    width: 100%;
    margin: -1px;
    &:hover {
      background: @border3Color;
    }
    // > div {
    //   text-align: center;
    //   line-height: 30px;
    // }
  }
  .history-cell {
    text-align: center;
    line-height: 30px;
    width: 12.5%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.history-no-data {
  text-align: center;
  font-size: 26px;
  line-height: 100px;
}

</style>
<style lang="less">
.check-code-class {
  .el-input__inner {
    border: 1px solid #f56c6c;
  }
}
</style>
